/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ModelProperty } from '../engine/model-property';

@Pipe({
  name: 'defaultValue',
  standalone: true,
})
export class DefaultValuePipe implements PipeTransform {
  transform(value: any, model: ModelProperty): any {
    if (!value && model.default_value) {
      if (model.default_value === '@default') {
        if (model.editType === 'time') {
          const pipe = new DatePipe('fr');
          return pipe.transform(new Date(), 'HH:mm');
        } else if (model.editType === 'date') {
          const pipe = new DatePipe('fr');
          return pipe.transform(new Date(), 'dd/MM/yyyy');
        }
      } else {
        return model.default_value;
      }
    } else {
      return value;
    }
  }
}
